"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LOCK_VALUES;
(function (LOCK_VALUES) {
    LOCK_VALUES[LOCK_VALUES["LOCKED"] = 0] = "LOCKED";
    LOCK_VALUES[LOCK_VALUES["UNLOCKED"] = 1] = "UNLOCKED";
    LOCK_VALUES[LOCK_VALUES["UNLOCKED_AND_AUTOMATIC_RELOCK_DISABLED"] = 2] = "UNLOCKED_AND_AUTOMATIC_RELOCK_DISABLED";
})(LOCK_VALUES || (LOCK_VALUES = {}));
exports.LOCK_VALUES = LOCK_VALUES;
var DATA_VALUES;
(function (DATA_VALUES) {
    DATA_VALUES[DATA_VALUES["UID"] = 0] = "UID";
    DATA_VALUES[DATA_VALUES["URL"] = 16] = "URL";
    DATA_VALUES[DATA_VALUES["TLM"] = 32] = "TLM";
    DATA_VALUES[DATA_VALUES["EID"] = 64] = "EID";
})(DATA_VALUES || (DATA_VALUES = {}));
exports.DATA_VALUES = DATA_VALUES;
//# sourceMappingURL=enums.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/eddystone-web-bluetooth/dist/beacon/enums.js
// module id = 187
// module chunks = 0